import { combineReducers } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import app, { AppStateType } from './app/reducers';
import loader, { LoaderStateType } from './loader/reducers';
import modal, { ModalStateType } from './modal/reducers';
import overlay, { OverlayStateType } from './overlay/reducers';
import toast, { ToastStateType } from './toast/reducers';
import pages, { PagesStateType } from './pages/reducers';
import profile, { ProfileStateType } from './profile/reducers';
import epg, { EPGWIdgetStateType } from './epg/reducers';
// import parental from './parental-lock';
// import player from './player';
import search, { SearchStateType } from './search/reducers';
export type RootStateType = {
  router: RouterState;
  app: AppStateType;
  loader: LoaderStateType;
  modal: ModalStateType;
  overlay: OverlayStateType;
  toast: ToastStateType;
  pages: PagesStateType;
  profile: ProfileStateType;
  search: SearchStateType;
  epg: EPGWIdgetStateType;
};

const createRootReducer = (history: History) => {
  return combineReducers<RootStateType>({
    router: connectRouter(history),
    app,
    search,
    epg,
    // search,
    // overlay,
    loader,
    modal,
    overlay,
    toast,
    pages,
    profile,
    // parental,
    // player,
  });
};

// export type RootStateType = ReturnType<typeof createRootReducer>;

export default createRootReducer;
